import axios from "@/libs/phpAxios";

interface PhpRespone {
  code: number;
  data: any;
  msg: string;
}

// 修改菜品上下架
export const changeFoodStatus = async (id: string): Promise<PhpRespone> => {
  return (
    await axios.request({
      method: "POST",
      url: "merch/food/change-status",
      data: {
        id
      }
    })
  ).data;
};

// 修改菜品库存
export const changeStock = async (
  foodId: string,
  stock: number
): Promise<PhpRespone> => {
  return (
    await axios.request({
      method: "POST",
      url: "merch/food/modify-stock",
      data: {
        foodId,
        stock
      }
    })
  ).data;
};

export const categoryList = async (): Promise<PhpRespone> => {
  return (await axios.request({
    method: "POST",
    url: "merch/category/find-list"
  })).data;
};

export const findFoodsByCategoryId = async (categoryId: string): Promise<PhpRespone> => {
  return (await axios.request({
    method: "POST",
    url: "merch/category/find-food-by-category",
    data: {
      category_id: categoryId
    }
  })).data;
};
